import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { Router } from '@angular/router';
import { createLegendListForSeatmapLayout } from '@common/helper';
import { SeatLegendDisplayInformation } from '@common/interfaces/servicing-seatmap/seat-legend-display-information';
import { MasterStoreKey } from '@conf/asw-master.config';
import { SupportModalBlockComponent } from '@lib/components/support-class';
import { MetaUrlPipe, StaticMsgPipe } from '@lib/pipes';
import { AswMasterService, CommonLibService } from '@lib/services';
import { take, zip } from 'rxjs';
import { getClassNameByCabinCodeByDynamic } from 'src/common/helper/common/seatmap.helper';

@Component({
  selector: 'asw-servicing-seatmap-layout-detail-modal',
  templateUrl: './servicing-seatmap-layout-detail-modal.component.html',
  styleUrls: ['./servicing-seatmap-layout-detail-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServicingSeatmapLayoutDetailModalComponent extends SupportModalBlockComponent {
  /** レイアウトイメージ */
  layoutImage?: string;

  /** 「さらに詳しく」ボタン押下時に開くURL */
  productUrl?: string;

  /** 凡例リスト */
  legendList?: SeatLegendDisplayInformation[];

  constructor(
    private _common: CommonLibService,
    private _router: Router,
    private _staticMsgPipe: StaticMsgPipe,
    private _masterService: AswMasterService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _metaUrlPipe: MetaUrlPipe
  ) {
    super(_common);
  }

  init(): void {
    // URLの変更時にモーダルが閉じられるよう設定する
    this.closeWithUrlChange(this._router);

    // 表示対象のセグメント
    const targetFlight = this.payload.displayTargetSegment;

    this.subscribeService(
      'ServicingSeatmapLayoutDetailModalComponent_init',
      zip(
        this._masterService.getAswMasterByKey$(MasterStoreKey.AIRCRAFT_CABIN_I18NJOIN_ACV_AND_CABIN).pipe(take(1)),
        this._masterService.getAswMasterByKey$(MasterStoreKey.EQUIPMENT_BY_ACV).pipe(take(1))
      ),
      ([mAircraftCabin, equipment]) => {
        // キャビン別機材情報マスタから対象のレコードを取得
        const version = targetFlight.aircraftConfigurationVersion;
        const cabinName = targetFlight.cabin ? targetFlight.cabin : undefined;
        const contentsServerUrl = this._masterService.getMPropertyByKey('seatMap', 'contents.server.url');
        if (!!version && !!cabinName) {
          const targetCabinRecord = mAircraftCabin?.[version]?.[cabinName]?.[0];

          // マスタからレイアウト画像を取得
          if (targetCabinRecord?.layout_image) {
            this.layoutImage = `${contentsServerUrl}${targetCabinRecord.layout_image}.png`;
          }
        }

        // 機種マスタからURLを取得
        if (!!version && !!equipment?.[version]?.[0]?.aircraft_type_url) {
          this.productUrl = this._metaUrlPipe.transform(equipment?.[version]?.[0]?.aircraft_type_url);
        }

        this.legendList = createLegendListForSeatmapLayout();

        this._changeDetectorRef.markForCheck();
      }
    );
  }

  destroy(): void {}

  reload(): void {}

  /**
   * キャビンコードからキャビンクラスの名称 (ex. エコノミークラス)を取得する。
   * @returns キャビンクラスの名称
   */
  getClassNameByCabinCode() {
    // isNeededToSupplementBookingClassをfalse, bookingClassを””(空欄)にしたオブジェクトを用意する。
    let displayTargetSegment = {
      ...this.payload.displayTargetSegment,
      isNeededToSupplementBookingClass: false,
      bookingClass: '',
    };

    return getClassNameByCabinCodeByDynamic(
      this._staticMsgPipe,
      this.payload.isInformative,
      displayTargetSegment,
      this.payload.cabinClasses,
      this.payload.informativeBookingClass,
      this.payload.isAwardBooking,
      true
    );
  }

  /**
   * 詳細表示ボタン押下
   */
  onClickSeatmapDetail() {
    window.open(this.productUrl, '_blank');
  }
}
